import axios, { AxiosError } from 'axios'
import { ResponseError } from 'integration/types'

const DEFAULT_ERROR_MESSAGE = 'Não foi possível completar a ação'

type ApiErrorPayload = ResponseError & {
  hasErrors?: boolean
}

const getMessageFromPayload = (payload: ApiErrorPayload | undefined): string | undefined => {
  return payload?.errors?.[0]
}

export const getApiErrorMessage = async (error: unknown): Promise<string> => {
  if (!axios.isAxiosError(error)) {
    return DEFAULT_ERROR_MESSAGE
  }

  const axiosError = error as AxiosError<ApiErrorPayload | Blob>

  const responseData = axiosError.response?.data

  if (!responseData) {
    return DEFAULT_ERROR_MESSAGE
  }

  if (responseData instanceof Blob) {
    try {
      const text = await responseData.text()

      const parsed = JSON.parse(text) as ApiErrorPayload

      const message = getMessageFromPayload(parsed)

      if (message) {
        return message
      }
    } catch {
      return DEFAULT_ERROR_MESSAGE
    }

    return DEFAULT_ERROR_MESSAGE
  }

  const message = getMessageFromPayload(responseData)

  return message ?? DEFAULT_ERROR_MESSAGE
}
